/**
 * Cwitness Component
 * Witness section for landing page with two-column layout
 * Left: Sticky hero + parallax text | Right: Scroll-triggered feature cards
 */
"use client";
import type { ReactElement } from "react";
import { useRef } from "react";
import { useViewportMetrics } from "@/hooks/dom";
import { CwitnessContent } from "./CwitnessContent";
import { buildCwitnessSectionStyle } from "./styles";
import type { CwitnessProps } from "./types";
export { CwitnessContent } from "./CwitnessContent";
export { WITNESS_CARD_IMAGE_SRCS } from "./constants";
export type { CwitnessContentProps, CwitnessProps } from "./types";
export function Cwitness({ className, style }: CwitnessProps): ReactElement {
    const { vh } = useViewportMetrics();
    const sectionRef = useRef<HTMLElement>(null);
    const sectionStyle = buildCwitnessSectionStyle({ vh, style });
    return (
      <section data-el="Cwitness/Root" ref={sectionRef} className={className} style={sectionStyle}>
        <CwitnessContent sectionRef={sectionRef}/>
      </section>
    );
}
